// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { classList } from '@Helpers/className';
import { Switch, SwitchProps } from 'antd';

import './THSwitch.scss';

type THSwitchProps = SwitchProps;

export const THSwitch = ({ className, ...props }: THSwitchProps): ReactElement => {
    return <Switch className={classList('th-switch', className)} size="small" {...props} />;
};
